import l from"lodash.kebabcase";const s=t=>{const o=[],e="string"==typeof t.weight?t.weight.toLowerCase():t.weight,a=l(t.name.trim()),n="fonts-"+a+"-style",r=t.fallback?', "'+t.fallback+'"':", "+t.type;var i;return"u"<typeof window?{className:`fonts-${a}-`+e,style:{fontFamily:t.name+r,fontWeight:t.weight},variable:"--font-"+a}:((i=window.document.createElement("style")).setAttribute("id",n+"-"+e),Array.isArray(t.url)&&t.url.length&&t.url.forEach(({path:t,format:e})=>{o.push(`url('${t}') format('${e}')`)}),i.appendChild(window.document.createTextNode(`
@font-face {
  font-family: '${t.name}';
  src: ${[...new Set(o)].join(",")};
}

:root {
  --font-${a}: "${t.name}", ${t.type};
}

.fonts-${a}-${e} {
  font-family: var(--font-${a});
  font-weight: ${e};
}
`)),window.document.getElementById(i.id)||window.document.getElementsByTagName("head")[0].appendChild(i),{className:`fonts-${a}-`+e,style:{fontFamily:t.name+", "+t.type,fontWeight:t.weight},variable:"--font-"+a})},w=t=>s({...t,name:"Kode Mono",type:"monospace",variable:!0,weight:t?.weight||400,url:[{format:"truetype",path:"https://raw.githubusercontent.com/isaozler/kode-mono/main/fonts/variable/KodeMono%5Bwght%5D.ttf"},{format:"woff2",path:"https://raw.githubusercontent.com/isaozler/kode-mono/main/fonts/webfonts/KodeMono%5Bwght%5D.woff2"}],fallback:"monospace"});export{w as KodeMono};
